export const PHONE_COUNTRIES = [
  { iso: "CO", name: "Colombia", dial: "+57" },
  { iso: "AR", name: "Argentina", dial: "+54" },
  { iso: "BO", name: "Bolivia", dial: "+591" },
  { iso: "BR", name: "Brasil", dial: "+55" },
  { iso: "CA", name: "Canadá", dial: "+1" },
  { iso: "CL", name: "Chile", dial: "+56" },
  { iso: "CR", name: "Costa Rica", dial: "+506" },
  { iso: "CU", name: "Cuba", dial: "+53" },
  { iso: "DO", name: "República Dominicana", dial: "+1" },
  { iso: "EC", name: "Ecuador", dial: "+593" },
  { iso: "SV", name: "El Salvador", dial: "+503" },
  { iso: "ES", name: "España", dial: "+34" },
  { iso: "US", name: "Estados Unidos", dial: "+1" },
  { iso: "GT", name: "Guatemala", dial: "+502" },
  { iso: "HT", name: "Haití", dial: "+509" },
  { iso: "HN", name: "Honduras", dial: "+504" },
  { iso: "IT", name: "Italia", dial: "+39" },
  { iso: "MX", name: "México", dial: "+52" },
  { iso: "NI", name: "Nicaragua", dial: "+505" },
  { iso: "PA", name: "Panamá", dial: "+507" },
  { iso: "PY", name: "Paraguay", dial: "+595" },
  { iso: "PE", name: "Perú", dial: "+51" },
  { iso: "PR", name: "Puerto Rico", dial: "+1" },
  { iso: "PT", name: "Portugal", dial: "+351" },
  { iso: "GB", name: "Reino Unido", dial: "+44" },
  { iso: "UY", name: "Uruguay", dial: "+598" },
  { iso: "VE", name: "Venezuela", dial: "+58" },
];

export const sanitizeNationalPhone = (value = "") =>
  String(value).replace(/[^0-9 ()-]/g, "");

export const nationalPhoneDigits = (value = "") =>
  String(value).replace(/\D/g, "").replace(/^0+/, "");

export const countryByIso = (iso = "CO") =>
  PHONE_COUNTRIES.find((country) => country.iso === iso) || PHONE_COUNTRIES[0];

export const buildWhatsAppE164 = (iso, national) => {
  const country = countryByIso(iso);
  const digits = nationalPhoneDigits(national);
  return digits ? `${country.dial}${digits}` : "";
};

export const splitWhatsAppE164 = (value = "", fallbackIso = "CO") => {
  const rawDigits = String(value).replace(/\D/g, "");
  if (!rawDigits) return { countryIso: fallbackIso, nationalNumber: "" };

  const fallback = countryByIso(fallbackIso);
  const candidates = PHONE_COUNTRIES
    .filter((country) => rawDigits.startsWith(country.dial.replace(/\D/g, "")))
    .sort((a, b) => b.dial.length - a.dial.length);

  let selected = candidates.find((country) => country.iso === fallback.iso);
  if (!selected && candidates.some((country) => country.dial === "+1")) {
    selected = candidates.find((country) => country.iso === "US");
  }
  selected = selected || candidates[0] || fallback;

  const dialDigits = selected.dial.replace(/\D/g, "");
  return {
    countryIso: selected.iso,
    nationalNumber: rawDigits.startsWith(dialDigits)
      ? rawDigits.slice(dialDigits.length)
      : rawDigits,
  };
};
